{
  "main": {
    "en": {
      "identity": {
        "version": {
          "_cldrVersion": "48.1"
        },
        "language": "en"
      },
      "numbers": {
        "currencies": {
          "AED": {
            "displayName": "United Arab Emirates Dirham",
            "symbol": "AED",
            "symbol-alt-narrow": "د.إ"
          },
          "AFN": {
            "displayName": "Afghan Afghani",
            "symbol": "AFN",
            "symbol-alt-narrow": "؋"
          },
          "ALL": {
            "displayName": "Albanian Lek",
            "symbol": "ALL",
            "symbol-alt-narrow": "L"
          },
          "AMD": {
            "displayName": "Armenian Dram",
            "symbol": "AMD",
            "symbol-alt-narrow": "դր."
          },
          "ANG": {
            "displayName": "Netherlands Antillean Guilder",
            "symbol": "ANG",
            "symbol-alt-narrow": "ƒ"
          },
          "AOA": {
            "displayName": "Angolan Kwanza",
            "symbol": "AOA",
            "symbol-alt-narrow": "Kz"
          },
          "ARS": {
            "displayName": "Argentine Peso",
            "symbol": "ARS",
            "symbol-alt-narrow": "$"
          },
          "AUD": {
            "displayName": "Australian Dollar",
            "symbol": "A$",
            "symbol-alt-narrow": "$"
          },
          "AWG": {
            "displayName": "Aruban Florin",
            "symbol": "AWG",
            "symbol-alt-narrow": "ƒ"
          },
          "AZN": {
            "displayName": "Azerbaijani Manat",
            "symbol": "AZN",
            "symbol-alt-narrow": "₼"
          },
          "BAM": {
            "displayName": "Bosnia-Herzegovina Convertible Mark",
            "symbol": "BAM",
            "symbol-alt-narrow": "КМ"
          },
          "BBD": {
            "displayName": "Barbadian Dollar",
            "symbol": "BBD",
            "symbol-alt-narrow": "$"
          },
          "BDT": {
            "displayName": "Bangladeshi Taka",
            "symbol": "BDT",
            "symbol-alt-narrow": "৳"
          },
          "BGN": {
            "displayName": "Bulgarian Lev",
            "symbol": "BGN",
            "symbol-alt-narrow": "лв"
          },
          "BHD": {
            "displayName": "Bahraini Dinar",
            "symbol": "BHD",
            "symbol-alt-narrow": "ب.د"
          },
          "BIF": {
            "displayName": "Burundian Franc",
            "symbol": "BIF",
            "symbol-alt-narrow": "Fr"
          },
          "BMD": {
            "displayName": "Bermudan Dollar",
            "symbol": "BMD",
            "symbol-alt-narrow": "$"
          },
          "BND": {
            "displayName": "Brunei Dollar",
            "symbol": "BND",
            "symbol-alt-narrow": "$"
          },
          "BOB": {
            "displayName": "Bolivian Boliviano",
            "symbol": "BOB",
            "symbol-alt-narrow": "Bs."
          },
          "BRL": {
            "displayName": "Brazilian Real",
            "symbol": "R$",
            "symbol-alt-narrow": "R$ "
          },
          "BSD": {
            "displayName": "Bahamian Dollar",
            "symbol": "BSD",
            "symbol-alt-narrow": "$"
          },
          "BTN": {
            "displayName": "Bhutanese Ngultrum",
            "symbol": "BTN",
            "symbol-alt-narrow": "Nu."
          },
          "BWP": {
            "displayName": "Botswanan Pula",
            "symbol": "BWP",
            "symbol-alt-narrow": "P"
          },
          "BYR": {
            "displayName": "Belarusian Ruble (2000–2016)",
            "symbol": "Br",
            "symbol-alt-narrow": "Br"
          },
          "BZD": {
            "displayName": "Belize Dollar",
            "symbol": "BZD",
            "symbol-alt-narrow": "$"
          },
          "CAD": {
            "displayName": "Canadian Dollar",
            "symbol": "CA$",
            "symbol-alt-narrow": "$"
          },
          "CDF": {
            "displayName": "Congolese Franc",
            "symbol": "CDF",
            "symbol-alt-narrow": "Fr"
          },
          "CHF": {
            "displayName": "Swiss Franc",
            "symbol": "CHF",
            "symbol-alt-narrow": "CHF "
          },
          "CLF": {
            "displayName": "Chilean Unit of Account (UF)",
            "symbol": "UF",
            "symbol-alt-narrow": "UF"
          },
          "CLP": {
            "displayName": "Chilean Peso",
            "symbol": "CLP",
            "symbol-alt-narrow": "$"
          },
          "CNY": {
            "displayName": "Chinese Yuan",
            "symbol": "CN¥",
            "symbol-alt-narrow": "¥"
          },
          "COP": {
            "displayName": "Colombian Peso",
            "symbol": "COP",
            "symbol-alt-narrow": "$"
          },
          "CRC": {
            "displayName": "Costa Rican Colón",
            "symbol": "CRC",
            "symbol-alt-narrow": "₡"
          },
          "CUC": {
            "displayName": "Cuban Convertible Peso",
            "symbol": "CUC",
            "symbol-alt-narrow": "$"
          },
          "CUP": {
            "displayName": "Cuban Peso",
            "symbol": "CUP",
            "symbol-alt-narrow": "$"
          },
          "CVE": {
            "displayName": "Cape Verdean Escudo",
            "symbol": "CVE",
            "symbol-alt-narrow": "$"
          },
          "CZK": {
            "displayName": "Czech Koruna",
            "symbol": "CZK",
            "symbol-alt-narrow": "Kč"
          },
          "DJF": {
            "displayName": "Djiboutian Franc",
            "symbol": "DJF",
            "symbol-alt-narrow": "Fdj"
          },
          "DKK": {
            "displayName": "Danish Krone",
            "symbol": "DKK",
            "symbol-alt-narrow": "kr"
          },
          "DOP": {
            "displayName": "Dominican Peso",
            "symbol": "DOP",
            "symbol-alt-narrow": "$"
          },
          "DZD": {
            "displayName": "Algerian Dinar",
            "symbol": "DZD",
            "symbol-alt-narrow": "د.ج"
          },
          "EGP": {
            "displayName": "Egyptian Pound",
            "symbol": "EGP",
            "symbol-alt-narrow": "ج.م"
          },
          "ERN": {
            "displayName": "Eritrean Nakfa",
            "symbol": "ERN",
            "symbol-alt-narrow": "Nfk"
          },
          "ETB": {
            "displayName": "Ethiopian Birr",
            "symbol": "ETB",
            "symbol-alt-narrow": "Br"
          },
          "EUR": {
            "displayName": "Euro",
            "symbol": "€",
            "symbol-alt-narrow": "€"
          },
          "FJD": {
            "displayName": "Fijian Dollar",
            "symbol": "FJD",
            "symbol-alt-narrow": "$"
          },
          "FKP": {
            "displayName": "Falkland Islands Pound",
            "symbol": "FKP",
            "symbol-alt-narrow": "£"
          },
          "GBP": {
            "displayName": "British Pound",
            "symbol": "£",
            "symbol-alt-narrow": "£"
          },
          "GEL": {
            "displayName": "Georgian Lari",
            "symbol": "GEL",
            "symbol-alt-narrow": "ლ"
          },
          "GHS": {
            "displayName": "Ghanaian Cedi",
            "symbol": "GHS",
            "symbol-alt-narrow": "₵"
          },
          "GIP": {
            "displayName": "Gibraltar Pound",
            "symbol": "GIP",
            "symbol-alt-narrow": "£"
          },
          "GMD": {
            "displayName": "Gambian Dalasi",
            "symbol": "GMD",
            "symbol-alt-narrow": "D"
          },
          "GNF": {
            "displayName": "Guinean Franc",
            "symbol": "GNF",
            "symbol-alt-narrow": "Fr"
          },
          "GTQ": {
            "displayName": "Guatemalan Quetzal",
            "symbol": "GTQ",
            "symbol-alt-narrow": "Q"
          },
          "GYD": {
            "displayName": "Guyanaese Dollar",
            "symbol": "GYD",
            "symbol-alt-narrow": "$"
          },
          "HKD": {
            "displayName": "Hong Kong Dollar",
            "symbol": "HK$",
            "symbol-alt-narrow": "$"
          },
          "HNL": {
            "displayName": "Honduran Lempira",
            "symbol": "HNL",
            "symbol-alt-narrow": "L"
          },
          "HRK": {
            "displayName": "Croatian Kuna",
            "symbol": "HRK",
            "symbol-alt-narrow": "kn"
          },
          "HTG": {
            "displayName": "Haitian Gourde",
            "symbol": "HTG",
            "symbol-alt-narrow": "G"
          },
          "HUF": {
            "displayName": "Hungarian Forint",
            "symbol": "HUF",
            "symbol-alt-narrow": "Ft"
          },
          "IDR": {
            "displayName": "Indonesian Rupiah",
            "symbol": "IDR",
            "symbol-alt-narrow": "Rp"
          },
          "ILS": {
            "displayName": "Israeli New Shekel",
            "symbol": "₪",
            "symbol-alt-narrow": "₪"
          },
          "INR": {
            "displayName": "Indian Rupee",
            "symbol": "₹",
            "symbol-alt-narrow": "₹"
          },
          "IQD": {
            "displayName": "Iraqi Dinar",
            "symbol": "IQD",
            "symbol-alt-narrow": "ع.د"
          },
          "IRR": {
            "displayName": "Iranian Rial",
            "symbol": "IRR",
            "symbol-alt-narrow": "﷼"
          },
          "ISK": {
            "displayName": "Icelandic Króna",
            "symbol": "ISK",
            "symbol-alt-narrow": "kr"
          },
          "JMD": {
            "displayName": "Jamaican Dollar",
            "symbol": "JMD",
            "symbol-alt-narrow": "$"
          },
          "JOD": {
            "displayName": "Jordanian Dinar",
            "symbol": "JOD",
            "symbol-alt-narrow": "د.ا"
          },
          "JPY": {
            "displayName": "Japanese Yen",
            "symbol": "¥",
            "symbol-alt-narrow": "¥"
          },
          "KES": {
            "displayName": "Kenyan Shilling",
            "symbol": "KES",
            "symbol-alt-narrow": "KSh"
          },
          "KGS": {
            "displayName": "Kyrgyz Som",
            "symbol": "KGS",
            "symbol-alt-narrow": "som"
          },
          "KHR": {
            "displayName": "Cambodian Riel",
            "symbol": "KHR",
            "symbol-alt-narrow": "៛"
          },
          "KMF": {
            "displayName": "Comorian Franc",
            "symbol": "KMF",
            "symbol-alt-narrow": "Fr"
          },
          "KPW": {
            "displayName": "North Korean Won",
            "symbol": "KPW",
            "symbol-alt-narrow": "₩"
          },
          "KRW": {
            "displayName": "South Korean Won",
            "symbol": "₩",
            "symbol-alt-narrow": "₩"
          },
          "KWD": {
            "displayName": "Kuwaiti Dinar",
            "symbol": "KWD",
            "symbol-alt-narrow": "د.ك"
          },
          "KYD": {
            "displayName": "Cayman Islands Dollar",
            "symbol": "KYD",
            "symbol-alt-narrow": "$"
          },
          "KZT": {
            "displayName": "Kazakhstani Tenge",
            "symbol": "KZT",
            "symbol-alt-narrow": "〒"
          },
          "LAK": {
            "displayName": "Laotian Kip",
            "symbol": "LAK",
            "symbol-alt-narrow": "₭"
          },
          "LBP": {
            "displayName": "Lebanese Pound",
            "symbol": "LBP",
            "symbol-alt-narrow": "ل.ل"
          },
          "LKR": {
            "displayName": "Sri Lankan Rupee",
            "symbol": "LKR",
            "symbol-alt-narrow": "₨"
          },
          "LRD": {
            "displayName": "Liberian Dollar",
            "symbol": "LRD",
            "symbol-alt-narrow": "$"
          },
          "LSL": {
            "displayName": "Lesotho Loti",
            "symbol": "LSL",
            "symbol-alt-narrow": "L"
          },
          "LTL": {
            "displayName": "Lithuanian Litas",
            "symbol": "Lt",
            "symbol-alt-narrow": "Lt"
          },
          "LVL": {
            "displayName": "Latvian Lats",
            "symbol": "Ls",
            "symbol-alt-narrow": "Ls"
          },
          "LYD": {
            "displayName": "Libyan Dinar",
            "symbol": "LYD",
            "symbol-alt-narrow": "ل.د"
          },
          "MAD": {
            "displayName": "Moroccan Dirham",
            "symbol": "MAD",
            "symbol-alt-narrow": "د.م."
          },
          "MDL": {
            "displayName": "Moldovan Leu",
            "symbol": "MDL",
            "symbol-alt-narrow": "L"
          },
          "MGA": {
            "displayName": "Malagasy Ariary",
            "symbol": "MGA",
            "symbol-alt-narrow": "Ar"
          },
          "MKD": {
            "displayName": "Macedonian Denar",
            "symbol": "MKD",
            "symbol-alt-narrow": "ден"
          },
          "MMK": {
            "displayName": "Myanmar Kyat",
            "symbol": "MMK",
            "symbol-alt-narrow": "K"
          },
          "MNT": {
            "displayName": "Mongolian Tugrik",
            "symbol": "MNT",
            "symbol-alt-narrow": "₮"
          },
          "MOP": {
            "displayName": "Macanese Pataca",
            "symbol": "MOP",
            "symbol-alt-narrow": "P"
          },
          "MRO": {
            "displayName": "Mauritanian Ouguiya (1973–2017)",
            "symbol": "UM",
            "symbol-alt-narrow": "UM"
          },
          "MUR": {
            "displayName": "Mauritian Rupee",
            "symbol": "MUR",
            "symbol-alt-narrow": "₨"
          },
          "MVR": {
            "displayName": "Maldivian Rufiyaa",
            "symbol": "MVR",
            "symbol-alt-narrow": "MVR"
          },
          "MWK": {
            "displayName": "Malawian Kwacha",
            "symbol": "MWK",
            "symbol-alt-narrow": "MK"
          },
          "MXN": {
            "displayName": "Mexican Peso",
            "symbol": "MX$",
            "symbol-alt-narrow": "$"
          },
          "MYR": {
            "displayName": "Malaysian Ringgit",
            "symbol": "MYR",
            "symbol-alt-narrow": "RM"
          },
          "MZN": {
            "displayName": "Mozambican Metical",
            "symbol": "MZN",
            "symbol-alt-narrow": "MTn"
          },
          "NAD": {
            "displayName": "Namibian Dollar",
            "symbol": "NAD",
            "symbol-alt-narrow": "$"
          },
          "NGN": {
            "displayName": "Nigerian Naira",
            "symbol": "NGN",
            "symbol-alt-narrow": "₦"
          },
          "NIO": {
            "displayName": "Nicaraguan Córdoba",
            "symbol": "NIO",
            "symbol-alt-narrow": "C$"
          },
          "NOK": {
            "displayName": "Norwegian Krone",
            "symbol": "NOK",
            "symbol-alt-narrow": "kr"
          },
          "NPR": {
            "displayName": "Nepalese Rupee",
            "symbol": "NPR",
            "symbol-alt-narrow": "₨"
          },
          "NZD": {
            "displayName": "New Zealand Dollar",
            "symbol": "NZ$",
            "symbol-alt-narrow": "$"
          },
          "OMR": {
            "displayName": "Omani Rial",
            "symbol": "OMR",
            "symbol-alt-narrow": "ر.ع."
          },
          "PAB": {
            "displayName": "Panamanian Balboa",
            "symbol": "PAB",
            "symbol-alt-narrow": "B/."
          },
          "PEN": {
            "displayName": "Peruvian Sol",
            "symbol": "PEN",
            "symbol-alt-narrow": "S/."
          },
          "PGK": {
            "displayName": "Papua New Guinean Kina",
            "symbol": "PGK",
            "symbol-alt-narrow": "K"
          },
          "PHP": {
            "displayName": "Philippine Peso",
            "symbol": "₱",
            "symbol-alt-narrow": "₱"
          },
          "PKR": {
            "displayName": "Pakistani Rupee",
            "symbol": "PKR",
            "symbol-alt-narrow": "₨"
          },
          "PLN": {
            "displayName": "Polish Zloty",
            "symbol": "PLN",
            "symbol-alt-narrow": "zł"
          },
          "PYG": {
            "displayName": "Paraguayan Guarani",
            "symbol": "PYG",
            "symbol-alt-narrow": "₲"
          },
          "QAR": {
            "displayName": "Qatari Riyal",
            "symbol": "QAR",
            "symbol-alt-narrow": "ر.ق"
          },
          "RON": {
            "displayName": "Romanian Leu",
            "symbol": "RON",
            "symbol-alt-narrow": "Lei"
          },
          "RSD": {
            "displayName": "Serbian Dinar",
            "symbol": "RSD",
            "symbol-alt-narrow": "РСД"
          },
          "RUB": {
            "displayName": "Russian Ruble",
            "symbol": "RUB",
            "symbol-alt-narrow": "р."
          },
          "RWF": {
            "displayName": "Rwandan Franc",
            "symbol": "RWF",
            "symbol-alt-narrow": "FRw"
          },
          "SAR": {
            "displayName": "Saudi Riyal",
            "symbol": "SAR",
            "symbol-alt-narrow": "ر.س"
          },
          "SBD": {
            "displayName": "Solomon Islands Dollar",
            "symbol": "SBD",
            "symbol-alt-narrow": "$"
          },
          "SCR": {
            "displayName": "Seychellois Rupee",
            "symbol": "SCR",
            "symbol-alt-narrow": "₨"
          },
          "SDG": {
            "displayName": "Sudanese Pound",
            "symbol": "SDG",
            "symbol-alt-narrow": "£"
          },
          "SEK": {
            "displayName": "Swedish Krona",
            "symbol": "SEK",
            "symbol-alt-narrow": "kr"
          },
          "SGD": {
            "displayName": "Singapore Dollar",
            "symbol": "SGD",
            "symbol-alt-narrow": "$"
          },
          "SHP": {
            "displayName": "St. Helena Pound",
            "symbol": "SHP",
            "symbol-alt-narrow": "£"
          },
          "SKK": {
            "displayName": "Slovak Koruna",
            "symbol": "Sk",
            "symbol-alt-narrow": "Sk"
          },
          "SLL": {
            "displayName": "Sierra Leonean Leone (1964—2022)",
            "symbol": "SLL",
            "symbol-alt-narrow": "Le"
          },
          "SOS": {
            "displayName": "Somali Shilling",
            "symbol": "SOS",
            "symbol-alt-narrow": "Sh"
          },
          "SRD": {
            "displayName": "Surinamese Dollar",
            "symbol": "SRD",
            "symbol-alt-narrow": "$"
          },
          "SSP": {
            "displayName": "South Sudanese Pound",
            "symbol": "SSP",
            "symbol-alt-narrow": "£"
          },
          "STD": {
            "displayName": "São Tomé & Príncipe Dobra (1977–2017)",
            "symbol": "Db",
            "symbol-alt-narrow": "Db"
          },
          "SVC": {
            "displayName": "Salvadoran Colón",
            "symbol": "₡",
            "symbol-alt-narrow": "₡"
          },
          "SYP": {
            "displayName": "Syrian Pound",
            "symbol": "SYP",
            "symbol-alt-narrow": "£S"
          },
          "SZL": {
            "displayName": "Swazi Lilangeni",
            "symbol": "SZL",
            "symbol-alt-narrow": "L"
          },
          "THB": {
            "displayName": "Thai Baht",
            "symbol": "THB",
            "symbol-alt-narrow": "฿"
          },
          "TJS": {
            "displayName": "Tajikistani Somoni",
            "symbol": "TJS",
            "symbol-alt-narrow": "ЅМ"
          },
          "TMT": {
            "displayName": "Turkmenistani Manat",
            "symbol": "TMT",
            "symbol-alt-narrow": "m"
          },
          "TND": {
            "displayName": "Tunisian Dinar",
            "symbol": "TND",
            "symbol-alt-narrow": "د.ت"
          },
          "TOP": {
            "displayName": "Tongan Paʻanga",
            "symbol": "TOP",
            "symbol-alt-narrow": "T$"
          },
          "TRY": {
            "displayName": "Turkish Lira",
            "symbol": "TRY",
            "symbol-alt-narrow": "TL"
          },
          "TTD": {
            "displayName": "Trinidad & Tobago Dollar",
            "symbol": "TTD",
            "symbol-alt-narrow": "$"
          },
          "TWD": {
            "displayName": "New Taiwan Dollar",
            "symbol": "NT$",
            "symbol-alt-narrow": "$"
          },
          "TZS": {
            "displayName": "Tanzanian Shilling",
            "symbol": "TZS",
            "symbol-alt-narrow": "Sh"
          },
          "UAH": {
            "displayName": "Ukrainian Hryvnia",
            "symbol": "UAH",
            "symbol-alt-narrow": "₴"
          },
          "UGX": {
            "displayName": "Ugandan Shilling",
            "symbol": "UGX",
            "symbol-alt-narrow": "USh"
          },
          "USD": {
            "displayName": "US Dollar",
            "symbol": "$",
            "symbol-alt-narrow": "$"
          },
          "UYU": {
            "displayName": "Uruguayan Peso",
            "symbol": "UYU",
            "symbol-alt-narrow": "$"
          },
          "UZS": {
            "displayName": "Uzbekistani Som",
            "symbol": "UZS",
            "symbol-alt-narrow": "лв"
          },
          "VEF": {
            "displayName": "Venezuelan Bolívar (2008–2018)",
            "symbol": "Bs F",
            "symbol-alt-narrow": "Bs F"
          },
          "VND": {
            "displayName": "Vietnamese Dong",
            "symbol": "₫",
            "symbol-alt-narrow": "₫"
          },
          "VUV": {
            "displayName": "Vanuatu Vatu",
            "symbol": "VUV",
            "symbol-alt-narrow": "Vt"
          },
          "WST": {
            "displayName": "Samoan Tala",
            "symbol": "WST",
            "symbol-alt-narrow": "T"
          },
          "XAF": {
            "displayName": "Central African CFA Franc",
            "symbol": "FCFA",
            "symbol-alt-narrow": "Fr"
          },
          "XAG": {
            "displayName": "Silver",
            "symbol": "oz t",
            "symbol-alt-narrow": "oz t"
          },
          "XAU": {
            "displayName": "Gold",
            "symbol": "oz t",
            "symbol-alt-narrow": "oz t"
          },
          "XCD": {
            "displayName": "East Caribbean Dollar",
            "symbol": "EC$",
            "symbol-alt-narrow": "$"
          },
          "XDR": {
            "displayName": "Special Drawing Rights",
            "symbol": "SDR",
            "symbol-alt-narrow": "SDR"
          },
          "XOF": {
            "displayName": "West African CFA Franc",
            "symbol": "F CFA",
            "symbol-alt-narrow": "Fr"
          },
          "XPF": {
            "displayName": "CFP Franc",
            "symbol": "CFPF",
            "symbol-alt-narrow": "Fr"
          },
          "YER": {
            "displayName": "Yemeni Rial",
            "symbol": "YER",
            "symbol-alt-narrow": "﷼"
          },
          "ZAR": {
            "displayName": "South African Rand",
            "symbol": "ZAR",
            "symbol-alt-narrow": "R"
          },
          "ZMK": {
            "displayName": "Zambian Kwacha (1968–2012)",
            "symbol": "ZK",
            "symbol-alt-narrow": "ZK"
          },
          "ZMW": {
            "displayName": "Zambian Kwacha",
            "symbol": "ZMW",
            "symbol-alt-narrow": "ZK"
          },
          "BTC": {
            "displayName": "Bitcoin",
            "symbol": "₿",
            "symbol-alt-narrow": "B⃦"
          },
          "JEP": {
            "displayName": "Jersey Pound",
            "symbol": "£",
            "symbol-alt-narrow": "£"
          },
          "EEK": {
            "displayName": "Estonian Kroon",
            "symbol": "KR",
            "symbol-alt-narrow": "KR"
          },
          "GHC": {
            "displayName": "Ghanaian Cedi (1979–2007)",
            "symbol": "₵",
            "symbol-alt-narrow": "₵"
          },
          "MTL": {
            "displayName": "Maltese Lira",
            "symbol": "₤",
            "symbol-alt-narrow": "₤"
          },
          "TMM": {
            "displayName": "Turkmenistani Manat (1993–2009)",
            "symbol": "m",
            "symbol-alt-narrow": "m"
          },
          "YEN": {
            "displayName": "Japanese Yen",
            "symbol": "¥",
            "symbol-alt-narrow": "¥"
          },
          "ZWD": {
            "displayName": "Zimbabwean Dollar (1980–2008)",
            "symbol": "$",
            "symbol-alt-narrow": "$"
          },
          "ZWL": {
            "displayName": "Zimbabwean Dollar (2009–2024)",
            "symbol": "$",
            "symbol-alt-narrow": "$"
          },
          "ZWN": {
            "displayName": "Zimbabwean Dollar",
            "symbol": "$",
            "symbol-alt-narrow": "$"
          },
          "ZWR": {
            "displayName": "Zimbabwean Dollar (2008)",
            "symbol": "$",
            "symbol-alt-narrow": "$"
          },
          "ZZC": {
            "displayName": "EURC",
            "symbol": "EURC",
            "symbol-alt-narrow": "€"
          },
          "VES": {
            "displayName": "Venezuelan Bolívar",
            "symbol": "VES",
            "symbol-alt-narrow": "Bs"
          },
          "MRU": {
            "displayName": "Mauritanian Ouguiya",
            "symbol": "MRU",
            "symbol-alt-narrow": "UM"
          },
          "BYN": {
            "displayName": "Belarusian Ruble",
            "symbol": "BYN",
            "symbol-alt-narrow": "Br"
          },
          "SLE": {
            "displayName": "Sierra Leonean Leone",
            "symbol": "SLE",
            "symbol-alt-narrow": "Le"
          },
          "STN": {
            "displayName": "São Tomé & Príncipe Dobra",
            "symbol": "STN",
            "symbol-alt-narrow": "Stn"
          },
          "ZZA": {
            "displayName": "USD Coin",
            "symbol": "USDC",
            "symbol-alt-narrow": "$"
          },
          "ZYI": {
            "displayName": "Sui Dollar",
            "symbol": "USDSUI",
            "symbol-alt-narrow": "$"
          },
          "ZZB": {
            "displayName": "USD Bridge",
            "symbol": "$",
            "symbol-alt-narrow": "$"
          },
          "ZWG": {
            "displayName": "Zimbabwean Gold",
            "symbol": "ZWG",
            "symbol-alt-narrow": "ZWG"
          },
          "XCG": {
            "displayName": "Caribbean guilder",
            "symbol": "Cg.",
            "symbol-alt-narrow": "Cg"
          },
          "ZZP": {
            "displayName": "Aptos",
            "symbol": "APT",
            "symbol-alt-narrow": "APT"
          },
          "ZZD": {
            "displayName": "Arbitrum",
            "symbol": "ARB",
            "symbol-alt-narrow": "ARB"
          },
          "ZZE": {
            "displayName": "Avalanche",
            "symbol": "AVAX",
            "symbol-alt-narrow": "AVAX"
          },
          "ZZF": {
            "displayName": "Binance Coin",
            "symbol": "BNB",
            "symbol-alt-narrow": "BNB"
          },
          "ZZQ": {
            "displayName": "BlackRock USD Institutional Digital Liquidity Fund",
            "symbol": "BUIDL",
            "symbol-alt-narrow": "BUIDL"
          },
          "ZZR": {
            "displayName": "Celo",
            "symbol": "CELO",
            "symbol-alt-narrow": "CELO"
          },
          "ZZG": {
            "displayName": "Dai",
            "symbol": "DAI",
            "symbol-alt-narrow": "DAI"
          },
          "ZYM": {
            "displayName": "Europe Reserve Dollar",
            "symbol": "ERD",
            "symbol-alt-narrow": "ERD"
          },
          "ZZH": {
            "displayName": "Ether",
            "symbol": "ETH",
            "symbol-alt-narrow": "ETH"
          },
          "ZYK": {
            "displayName": "Fidelity Digital Dollar",
            "symbol": "FIDD",
            "symbol-alt-narrow": "$"
          },
          "ZZS": {
            "displayName": "Frax USD",
            "symbol": "FRXUSD",
            "symbol-alt-narrow": "FRXUSD"
          },
          "ZZT": {
            "displayName": "Hyperliquid",
            "symbol": "HYPE",
            "symbol-alt-narrow": "HYPE"
          },
          "ZZU": {
            "displayName": "Lazard Dollar",
            "symbol": "LZD",
            "symbol-alt-narrow": "LZD"
          },
          "ZZV": {
            "displayName": "M Token",
            "symbol": "M",
            "symbol-alt-narrow": "M"
          },
          "ZZW": {
            "displayName": "Monad",
            "symbol": "MON",
            "symbol-alt-narrow": "MON"
          },
          "ZYL": {
            "displayName": "MXNB",
            "symbol": "MXNB",
            "symbol-alt-narrow": "MXNB"
          },
          "ZZX": {
            "displayName": "Open Reserve Dollar",
            "symbol": "ORD",
            "symbol-alt-narrow": "ORD"
          },
          "ZZJ": {
            "displayName": "Polygon Ecosystem Token",
            "symbol": "POL",
            "symbol-alt-narrow": "POL"
          },
          "ZZK": {
            "displayName": "PayPal USD",
            "symbol": "PYUSD",
            "symbol-alt-narrow": "$"
          },
          "ZZY": {
            "displayName": "Reserve Dollar",
            "symbol": "RD",
            "symbol-alt-narrow": "RD"
          },
          "ZZZ": {
            "displayName": "Reserve Euro",
            "symbol": "RE",
            "symbol-alt-narrow": "RE"
          },
          "ZZL": {
            "displayName": "Solana",
            "symbol": "SOL",
            "symbol-alt-narrow": "SOL"
          },
          "ZYA": {
            "displayName": "Sui",
            "symbol": "SUI",
            "symbol-alt-narrow": "SUI"
          },
          "ZZM": {
            "displayName": "Tronix",
            "symbol": "TRX",
            "symbol-alt-narrow": "TRX"
          },
          "ZYB": {
            "displayName": "Global Dollar",
            "symbol": "USDG",
            "symbol-alt-narrow": "USDG"
          },
          "ZZN": {
            "displayName": "Pax Dollar",
            "symbol": "USDP",
            "symbol-alt-narrow": "$"
          },
          "ZZO": {
            "displayName": "Tether",
            "symbol": "USDT",
            "symbol-alt-narrow": "$"
          },
          "ZZI": {
            "displayName": "Open USD",
            "symbol": "OPEN_USD",
            "symbol-alt-narrow": "$"
          },
          "ZYJ": {
            "displayName": "Open USD",
            "symbol": "OUSD",
            "symbol-alt-narrow": "$"
          },
          "ZYC": {
            "displayName": "Superstate Short Duration US Government Securities Fund",
            "symbol": "USTB",
            "symbol-alt-narrow": "USTB"
          },
          "ZYD": {
            "displayName": "XDC Network",
            "symbol": "XDC",
            "symbol-alt-narrow": "XDC"
          },
          "ZYE": {
            "displayName": "Euro Stablecoin",
            "symbol": "XEUR",
            "symbol-alt-narrow": "XEUR"
          },
          "ZYF": {
            "displayName": "Stellar Lumens",
            "symbol": "XLM",
            "symbol-alt-narrow": "XLM"
          },
          "ZYG": {
            "displayName": "XPL",
            "symbol": "XPL",
            "symbol-alt-narrow": "XPL"
          },
          "ZYH": {
            "displayName": "X Dollar",
            "symbol": "XUSD",
            "symbol-alt-narrow": "XUSD"
          }
        }
      }
    }
  }
}